import { useCallback, useEffect, useRef, useState } from "react";

export function useHeaderScroll(containerRef: React.RefObject<HTMLElement | null>) {
	const [hidden, setHidden] = useState(false);
	const lastScrollY = useRef(0);
	const threshold = 10;

	const onScroll = useCallback(() => {
		const el = containerRef.current;
		if (!el) return;
		const y = el.scrollTop;
		const dy = y - lastScrollY.current;

		if (y < threshold) {
			setHidden(false);
		} else if (dy > threshold) {
			setHidden(true);
		} else if (dy < -threshold) {
			setHidden(false);
		}
		lastScrollY.current = y;
	}, [containerRef]);

	useEffect(() => {
		const el = containerRef.current;
		if (!el) return;
		el.addEventListener("scroll", onScroll, { passive: true });
		return () => el.removeEventListener("scroll", onScroll);
	}, [onScroll, containerRef]);

	return hidden;
}
